function parseCalendarDate(value: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T00:00:00.000Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value || date.getUTCFullYear() === 0) return null;
  return date;
}

function calendarMidnightUtc(calendarDate: Date, formatter: Intl.DateTimeFormat): Date | null {
  const target = calendarDate.getTime();
  let candidate = target;
  for (let attempt = 0; attempt < 4; attempt += 1) {
    const parts = formatter.formatToParts(new Date(candidate));
    const part = (type: string) => Number(parts.find(item => item.type === type)?.value);
    const wallDate = new Date(0);
    wallDate.setUTCFullYear(part('year'), part('month') - 1, part('day'));
    wallDate.setUTCHours(part('hour'), part('minute'), part('second'), 0);
    const correction = target - wallDate.getTime();
    if (correction === 0) return new Date(candidate);
    candidate += correction;
  }
  return null;
}

export function timezoneDateRange(startDate: string, endDate: string, timezone: string): { startUtc: string; endExclusiveUtc: string } | null {
  const start = parseCalendarDate(startDate);
  const end = parseCalendarDate(endDate);
  if (!start || !end || end < start || !timezone.trim()) return null;
  end.setUTCDate(end.getUTCDate() + 1);
  try {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    });
    const startUtc = calendarMidnightUtc(start, formatter);
    const endExclusiveUtc = calendarMidnightUtc(end, formatter);
    if (!startUtc || !endExclusiveUtc || endExclusiveUtc <= startUtc) return null;
    return { startUtc: startUtc.toISOString(), endExclusiveUtc: endExclusiveUtc.toISOString() };
  } catch {
    return null;
  }
}

export function timezoneDateRangeFilters(startDate: string, endDate: string, timezone: string): { startUtc: string; endUtc: string } | null {
  const range = timezoneDateRange(startDate, endDate, timezone);
  return range ? { startUtc: range.startUtc, endUtc: new Date(Date.parse(range.endExclusiveUtc) - 1).toISOString() } : null;
}